module.exports = __webpack_public_path__ + "img/icon-arrow.446fd624.svg";